import _ from '../../core/utils'
import MODAL_CONFIG from './config'

class ModalClass {
    constructor() {
        this.DOM = {
            openers: MODAL_CONFIG.openers,
            closers: MODAL_CONFIG.closers
        }

        this.init()
    }

    init() {
        this._listeners()
    }

    _listeners() {
        this.DOM.openers.forEach( ( opener ) => { opener.addEventListener( 'click', this._open.bind( this ) ) } )
        this.DOM.closers.forEach( ( closer ) => { closer.addEventListener( 'click', this._close.bind( this ) ) } )
    }

    _open() {
        let modalId = event.currentTarget.getAttribute( 'data-modal' ),
            modal = _.select( `.fl__modal[data-modal="${modalId}"]` )

        _.addClass( modal, 'fl__active' )
    }

    _close() {
        let modal = _.select( '.fl__modal.fl__active' )
        modal ? _.removeClass( modal, 'fl__active' ) : null
    }
}

const MODAL = new ModalClass()
export default MODAL